/* Progressive enhancement for these two Mini components only. No dependencies. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const accordions = [];

  document.querySelectorAll('[data-mini-faq] details').forEach((details) => {
    const summary = details.querySelector('summary');
    const answer = details.querySelector('.mini-faq-panel__answer, :scope > p');
    if (!summary || !answer || typeof details.animate !== 'function') return;
    let animation = null;
    let expanded = details.open;

    const settle = () => {
      const previous = animation;
      animation = null;
      if (previous) previous.cancel();
      details.open = expanded;
      details.style.height = '';
      details.style.overflow = '';
      details.dataset.expanding = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      answer.inert = !expanded;
    };
    accordions.push(settle);
    summary.setAttribute('aria-expanded', String(expanded));
    answer.inert = !expanded;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      expanded = !expanded;
      const from = details.getBoundingClientRect().height;
      if (animation) animation.cancel();
      animation = null;
      details.open = true;
      details.dataset.expanding = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      answer.inert = !expanded;
      if (reducedMotion.matches) { settle(); return; }
      const style = getComputedStyle(details);
      const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const collapsed = summary.getBoundingClientRect().height + border;
      const to = expanded ? collapsed + answer.getBoundingClientRect().height : collapsed;
      details.style.height = `${from}px`;
      details.style.overflow = 'hidden';
      const current = details.animate({height:[`${from}px`,`${to}px`]}, {
        duration:280, easing:'cubic-bezier(.22, 1, .36, 1)'
      });
      animation = current;
      current.onfinish = () => { if (animation === current) settle(); };
    });
    // Browser-native opening (for example find-in-page) must remain authoritative.
    details.addEventListener('toggle', () => {
      if (animation) return;
      expanded = details.open;
      details.dataset.expanding = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      answer.inert = !expanded;
    });
  });

  window.addEventListener('resize', () => accordions.forEach(settle => settle()), {passive:true});
  reducedMotion.addEventListener('change', () => accordions.forEach(settle => settle()));
})();
